import { useEffect, useState } from "react";
import { billingApi } from "../api/businessData.js";

function daysLeft(dateStr) {
  if (!dateStr) return null;
  const diffMs = new Date(dateStr).getTime() - Date.now();
  return Math.max(0, Math.ceil(diffMs / (24 * 60 * 60 * 1000)));
}

export function BillingStatus() {
  const [status, setStatus] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [buyingPack, setBuyingPack] = useState(false);

  useEffect(() => {
    billingApi.getStatus().then(setStatus).catch(() => {});
  }, []);

  if (!status || !status.subscription) return null;

  const { subscription, usage, plans, overagePack } = status;
  const isTrial = subscription.status === "trialing";
  const planDef = plans[subscription.plan];

  async function buyOveragePack() {
    setBuyingPack(true);
    try {
      const { redirectUrl } = await billingApi.checkoutOveragePack();
      window.location.href = redirectUrl;
    } catch {
      setBuyingPack(false);
    }
  }

  return (
    <div style={{ position: "relative", fontSize: 11 }}>
      <button
        onClick={() => setExpanded((v) => !v)}
        style={{
          background: "#fff",
          border: "1px solid #DDD",
          borderRadius: 8,
          padding: "4px 10px",
          cursor: "pointer",
          color: "#383853",
          fontWeight: 600,
        }}
      >
        {isTrial
          ? `Bandomasis: ${daysLeft(subscription.trialEndsAt)} d. liko`
          : `Planas ${planDef?.name ?? subscription.plan}-${usage.estimatesThisMonth}${planDef?.estimateLimit ? `/${planDef.estimateLimit + usage.overagePacksThisMonth * overagePack.extraEstimates}` : ""}`}
      </button>

      {expanded && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            right: 0,
            background: "#fff",
            border: "1px solid #DDD",
            borderRadius: 10,
            padding: 16,
            width: 260,
            boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          {isTrial ? (
            <>
              <div style={{ fontWeight: 700, marginBottom: 4 }}>Bandomasis laikotarpis</div>
              <div style={{ color: "#383853", marginBottom: 8 }}>
                Liko {daysLeft(subscription.trialEndsAt)} dienų. Pasibaigus reikės pasirinkti planą.
              </div>
            </>
          ) : (
            <>
              <div style={{ fontWeight: 700, marginBottom: 4 }}>{planDef?.name} planas</div>
              <div style={{ color: "#383853", marginBottom: 8 }}>
                Panaudota {usage.estimatesThisMonth} sąmatų šį mėnesį
                {planDef?.estimateLimit ? ` iš ${planDef.estimateLimit + usage.overagePacksThisMonth * overagePack.extraEstimates}` : " (neribotai)"}.
              </div>
              {planDef?.estimateLimit && (
                <button
                  onClick={buyOveragePack}
                  disabled={buyingPack}
                  className="w-full px-3 py-1.5 text-xs font-semibold rounded-lg bg-ral3000 text-white hover:bg-ral3000-dark disabled:opacity-60"
                >
                  {buyingPack ? "Nukreipiama..." : `+${overagePack.extraEstimates} sąmatų už €${(overagePack.priceCents / 100).toFixed(2)}`}
                </button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
